export const LOC_KEY_NO_ITEMS = "GUI-489002"; // Žádné záznamy. V tomto seznamu nemáme co zobrazit.
export const LOC_KEY_NO_ITEMS_FULLTEXT_SEARCH = "GUI-702817"; //Snažili jsme se usilovně, ale '@TEXT' jsme nenašli.
export const LOC_KEY_NO_ITEMS_FILTER = "GUI-488998"; //Rádi bychom něco zobrazili, ale zadaný filtr nám to nedovoluje.
export const LOC_KEY_YES = "GUI-146838";
export const LOC_KEY_NO = "GUI-146840";
export const LOC_KEY_WORKFLOW_ACTIONS = "GUI-772184"; // Zobrazit workflow akce

/**
 * Obsahuje staticky definované lokalizační klíče pro framy.
 */
export const staticLocKeys = [
    LOC_KEY_NO_ITEMS,
    LOC_KEY_NO_ITEMS_FULLTEXT_SEARCH,
    LOC_KEY_NO_ITEMS_FILTER,
    LOC_KEY_YES,
    LOC_KEY_NO,
    LOC_KEY_WORKFLOW_ACTIONS,
];
